import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0642bd55&scoped=true"
var script = {}
import style0 from "../public/css/main.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=0642bd55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642bd55",
  null
  
)

export default component.exports